<template>
	<div class="service-wrap">
        <h1>服务信息</h1>
		<ul class='service-content'>
            <li class="first">
                <p>订单编号：<span>{{detailInfo.order_code}}</span></p>
                <p class="create-time">下单时间：<span>{{detailInfo.create_time}}</span></p>
                <p class="pay-type"><span v-if='detailInfo.pay_type'>支付方式：</span><span v-if='detailInfo.pay_type'>{{detailInfo.pay_type | filterPay}}</span></p>
            </li>
            
            <li class="two">
                <div>
                    <span>服务项目</span>
                    <div>
                        <img :src="detailInfo.server_info.server_icon | filterImg(self)">
                        <em>{{detailInfo.server_info && detailInfo.server_info.server_name}}</em>
                    </div>
                </div>
                
                <div>
                    <span>订单价格</span>
                    <p class="money">{{detailInfo.order_server_price}}元</p>
                </div>
                
                <div>
                    <span>追加费用</span>
                    <p>{{detailInfo.order_append_price}}元</p>
                </div>
                
                <div>
                    <span>优惠信息</span>
                    <p>{{detailInfo.order_member_price}}</p>
                </div>
                
                <div>
                    <span>合计金额</span>
                    <p class="money">{{detailInfo.order_total_price}}元</p>
                </div>
            </li>
            
            <li class="three" v-if='detailInfo.order_details'>
                <span>情况概述：</span>
                <p>{{detailInfo.order_details}}</p>
            </li>
            
            <li class="four no-border" v-if='(detailInfo.after_sale_type==2 && detailInfo.compensation_price) || (detailInfo.after_sale_type==4 && detailInfo.other_sale_massage) || detailInfo.after_sale_name'>
                <span>售后特权：</span>
                <div v-if="detailInfo.after_sale_type==2">
                    <span class="max-money">最大允许补偿金额</span>
                    <span>¥{{detailInfo.compensation_price}}</span>
                </div>
                
                <div v-else-if="detailInfo.after_sale_type==4">{{detailInfo.other_sale_massage}}</div>
                <div v-else>{{detailInfo.after_sale_name}}</div>
            </li>
        </ul>
        
		
	</div>
</template>

<script>
    import {mapState} from "vuex";
export default {
    props:{
        detailInfo:{
           type:Object,
           default:()=>{}
        } 
    },
    data() {
    	return {
			self:this
		};
    },
    
    computed: {
    	...mapState(["communalInfo"]),
    },
    
    filters:{
        filterImg(val,self){
            if(val){
                if(val.includes("http") || val.includes("https")){
                    return val;
                }
                else{
                    return self.communalInfo.BucketDomain + val;
                }
            }
        },
        
        filterPay(val){
            if(val.indexOf("支付") > -1){
                return val.slice(0,-2);
            }
            else{
                return val;
            }
        }
    },
  
    methods:{
        
    },
};
</script>

<style lang="scss" scoped>
	.service-wrap{
        h1{
            font-size: 20px;
            @include font-style;
            color: #000000;
        }
        .service-content{
            width: 100%;
            @include box-style;
            padding: 25px 30px;
            margin-top: 20px;
            background: #FFFFFF;
            box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
            li{
                border-bottom: 1px solid #CCCCCC;
            }
            .first{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 18px;
                color: #666666;
                padding-bottom: 26px;
                @include font-style;
                .pay-type{
                    width: 180px;
                }
            }
            .two{
                display: flex;
                align-items: center;
                padding: 30px 0;
                > div{
                    width: 20%; 
                    text-align: center;
                    span{
                       @include font-style;
                       display: inline-block;
                       font-size: 18px;
                       color: #666666;
                       margin-bottom: 20px;
                       
                    }
                    p{
                        
                        font-size: 21px;
                        @include font-style;
                        color: #343434;
                    }
                    .money{
                        font-size: 20px;
                        color: #FF8E1C;
                    }
                    em{
                        @extend p;
                        font-size: 20px;
                        vertical-align: middle;
                        padding-left: 11px;
                        font-style: normal;
                    }
                }
                img{
                    vertical-align: middle;
                    width: 20px;
                    height: 20px;
                }
            }
            .three{
                padding: 30px 0;
                display: flex;
                font-size: 18px;
                @include font-style;
                border-bottom: none;
                span{
                   color: #666666; 
                }
                p{
                    flex: 1;
                    margin-left: 20px;
                    color: #343434;
                    word-break: break-all;
                }
            }
            .four{
                display: flex;
                align-items: center;
                font-size: 18px;
                @include font-style;
                color: #666666;
                padding-top: 24px;
                border-bottom: none;
                div{
                    margin-left: 20px;
                }
                .max-money{
                    margin-right: 20px;
                }
            }
        }
    }
	
</style>